









































































import { Component, Watch } from 'vue-property-decorator';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import UpdateJourneyTemplateRequest from '@/models/JourneyTemplates/UpdateJourneyTemplateRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import JourneyTemplateDto from '@/models/JourneyTemplates/JourneyTemplateDto';
import ListUtils from '@/lib/listUtils';

@Component({
    name: 'JourneyTemplateEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new JourneyTemplateDto();

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(LocationDetailsModule.currentJourneyTemplate));
    }
  }

  get loading() {
    return LocationDetailsModule.loadingDialog;
  }

  get travelTimes() {
    return ListUtils.travelTimes();
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateJourneyTemplateRequest()
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    request.distanceOneWay = Number(this.entity.distanceOneWay)
    request.travelTimeOneWay = this.entity.travelTimeOneWay
    await LocationDetailsModule.editJourneyTemplate(request)
    this.dialog = false;
  }
}
